/* Heavenly Minded Threads — global interactions (vanilla, no deps) */
(function () {
  'use strict';
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    try { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Drawer / overlay controller ---------- */
  const backdrop = qs('[data-backdrop]');
  let openEl = null, lastFocus = null;

  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function open(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    openEl = el;
    el.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    lockScroll(true);
    el.setAttribute('aria-hidden', 'false');
    const focusable = el.querySelector('input, button, a, [tabindex]');
    if (focusable) setTimeout(() => focusable.focus(), 60);
  }
  function close() {
    if (!openEl) return;
    openEl.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    lockScroll(false);
    openEl.setAttribute('aria-hidden', 'true');
    if (lastFocus) lastFocus.focus();
    openEl = null;
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); const t = qs('#' + opener.getAttribute('data-open')); open(t); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); close(); }
  });
  if (backdrop) backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  /* ---------- Cart ---------- */
  const cartDrawer = qs('#cart-drawer');

  function refreshSection(html) {
    if (!cartDrawer || !html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector('#cart-drawer .drawer__inner');
    const current = cartDrawer.querySelector('.drawer__inner');
    if (fresh && current) current.replaceWith(fresh);
  }
  function updateCount(count) {
    qsa('[data-cart-count]').forEach((n) => { n.textContent = count; n.classList.toggle('is-empty', count === 0); });
  }

  async function addToCart(form) {
    const btn = form.querySelector('[type="submit"]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    const data = new FormData(form);
    data.append('sections', 'cart-drawer');
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data });
      const json = await res.json();
      if (!res.ok) throw json;
      if (json.sections && json.sections['cart-drawer']) refreshSection(json.sections['cart-drawer']);
      const cart = await (await fetch('/cart.js')).json();
      updateCount(cart.item_count);
      open(cartDrawer);
    } catch (err) {
      if (btn) btn.textContent = (err && err.description) ? err.description : 'Unavailable';
      setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1600);
      return;
    }
    if (btn) { btn.disabled = false; btn.textContent = label; }
  }

  async function changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    });
    const json = await res.json();
    if (json.sections && json.sections['cart-drawer']) refreshSection(json.sections['cart-drawer']);
    updateCount(json.item_count);
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-cart-add]');
    if (form) { e.preventDefault(); addToCart(form); }
  });
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      const line = q.getAttribute('data-line');
      const dir = q.getAttribute('data-qty-change');
      const input = q.parentElement.querySelector('input');
      let val = parseInt(input.value, 10) + (dir === 'up' ? 1 : -1);
      if (val < 0) val = 0;
      input.value = val; changeLine(parseInt(line, 10), val); return;
    }
    const rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-remove-line'), 10), 0); }
  });

  /* ---------- Predictive search ---------- */
  const searchInput = qs('[data-predictive-input]');
  const searchResults = qs('[data-predictive-results]');
  let searchTimer;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const term = searchInput.value.trim();
      if (term.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const url = '/search/suggest.json?q=' + encodeURIComponent(term) +
            '&resources[type]=product,collection,page&resources[limit]=6';
          const data = await (await fetch(url)).json();
          const products = (data.resources.results.products || []);
          let html = '';
          if (products.length) {
            html += '<p class="predictive__section-title">Products</p>';
            products.forEach((p) => {
              const img = p.featured_image ? p.featured_image.url : (p.image || '');
              html += '<a class="predictive__product" href="' + p.url + '">' +
                (img ? '<img src="' + img + '&width=120" alt="" loading="lazy">' : '<span></span>') +
                '<span>' + p.title + '</span><span class="muted">' + (p.price || '') + '</span></a>';
            });
          } else {
            html = '<p class="muted">No results for “' + term + '”.</p>';
          }
          searchResults.innerHTML = html;
        } catch (e) { /* silent */ }
      }, 220);
    });
  }

  /* ---------- Sticky mobile add-to-cart ---------- */
  const stickyBar = qs('[data-pdp-sticky]');
  const primaryAtc = qs('[data-pdp-atc]');
  if (stickyBar && primaryAtc && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => stickyBar.classList.toggle('is-visible', !en.isIntersecting));
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(primaryAtc);
  }
})();
